<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol
                    ><h1 class="page__title">{{ $t(titlePage) }}</h1></CCol
                >
                <CCol>
                    <ButtonCreate
                        :title="$t('create_campaing')"
                        @click="
                            $router.push({
                                name: 'view_campaign',
                                query: {
                                    view_type: 'new',
                                },
                            })
                        "
                    >
                        {{ $t("create_campaing") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <!-- Filter -->
                <CRow class="justify-content-end p-2 mb-4">
                    <CCol md="5" sm="12">
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <!-- Data chart -->
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'campaigns',
                        })
                    "
                >
                    <CCol xl="12" md="12">
                        <CCard class="position-relative shadow">
                            <CCardHeader>
                                <h3 class="m-0">
                                    {{ $t("campaings_activity") }}
                                </h3>
                                <h5 class="text-gray-50">
                                    {{ $t("data_flow") }}
                                </h5>
                            </CCardHeader>
                            <CCardBody>
                                <CChartLine
                                    style="height: 350px"
                                    :labels="
                                        charts.providers_input_history.labels
                                    "
                                    :datasets="
                                        charts.providers_input_history.datasets
                                    "
                                    :options="
                                        charts.providers_input_history.options
                                    "
                                />
                            </CCardBody>

                            <CElementCover
                                v-show="charts.providers_input_history.loading"
                                :opacity="1"
                            >
                                <CSpinner
                                    style="width: 4rem; height: 4rem"
                                    color="primary"
                                />
                            </CElementCover>
                        </CCard>
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.campaigns.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <!-- Data table -->
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'campaigns',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <CContainer :fluid="true">
                                    <CRow>
                                        <CCol>
                                            <h3 class="m-0">
                                                {{ $t("campaings_list") }}
                                            </h3>
                                        </CCol>
                                        <CCol>
                                            <TableSettings
                                                :allFields="
                                                    tables.campaigns.allFields
                                                "
                                                :activeFields.sync="
                                                    tables.campaigns.fields
                                                "
                                            />
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </CCardHeader>
                            <CCardBody>
                                <CCTable
                                    :responsive="true"
                                    :addTableClasses="['table--sm']"
                                    :items="tables.campaigns.items"
                                    :fields="tables.campaigns.fields"
                                    :columnFilterValue.sync="
                                        tables.campaigns.columnFilterValue
                                    "
                                    :sorterValue.sync="
                                        tables.campaigns.sorterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.campaigns.rows"
                                    v-bind="tables.campaigns"
                                    :resizable="false"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables.campaigns
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'input_campaign_details',
                                                                params: {
                                                                    uuid: tables
                                                                        .campaigns
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{ $t("Details") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'view_campaign',
                                                                query: {
                                                                    view_type:
                                                                        'edit',
                                                                    uuid: tables
                                                                        .campaigns
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{
                                                            $t("edit_campaign")
                                                        }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'campaign_leads',
                                                                params: {
                                                                    uuid: tables
                                                                        .campaigns
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{ $t("leads") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'campaign_answers',
                                                                params: {
                                                                    uuid: tables
                                                                        .campaigns
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{ $t("answers") }}
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #_selected="{ item }">
                                        <CInputRadio
                                            name="_selected"
                                            :checked="
                                                item ===
                                                tables.campaigns.itemSelected
                                            "
                                            @update:checked="
                                                selectItemTable(
                                                    'campaigns',
                                                    item
                                                )
                                            "
                                        />
                                    </template>
                                    <template #avg="{ item }">
                                        <ChartGauge
                                            :value="item.avg"
                                            size="sm"
                                        />
                                    </template>
                                    <template #cappingPercentatge="{ item }">
                                        <ChartGauge
                                            :value="item.cappingPercentatge"
                                            size="sm"
                                        />
                                    </template>
                                    <template #active="{ item }">
                                        <CBadge
                                            :color="getBadge(item.active).color"
                                        >
                                            {{
                                                $t(getBadge(item.active).label)
                                            }}
                                        </CBadge>
                                    </template>
                                    <template #created_at="{ item }">
                                        {{ item.created_at.split(" ")[0] }}
                                    </template>
                                    <template #updated_at="{ item }">
                                        {{ item.updated_at.split(" ")[0] }}
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="'input.api/list'"
                                                :table="tables.campaigns"
                                            />
                                        </div>
                                    </template>
                                </CCTable>
                            </CCardBody>
                            <CCardFooter>
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.campaigns.page"
                                        :pages="tables.campaigns.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.campaigns.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'campaigns',
                    })
                "
            >
                <template #title> Create you first Campaing </template>
                <template #description>
                    {{
                        $t(
                            "create_and_configure_all_fields_and_data_destination_for_any_type_of_campaign_you_want_to_activate"
                        )
                    }}
                </template>
                <template #redirect>
                    <ButtonCreate
                        :title="$t('add_new_campaign')"
                        @click="
                            $router.push({
                                name: 'view_campaign',
                                query: {
                                    view_type: 'new',
                                },
                            })
                        "
                    >
                        {{ $t("create_my_first_campaign!") }}
                    </ButtonCreate>
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'campaigns',
                            })
                        "
                        @click="cleanFiltersAdvance('campaigns'), updateData()"
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean Filter") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import CCTable from "~/components/CCTable";
import FilterDate from "~/components/FilterDate";
import FilterFields from "~/components/FilterFields";
import ButtonCreate from "~/components/ButtonCreate";
import ButtonExport from "~/components/ButtonExport";
import TableSettings from "£lement/TableSettings";
import ChartGauge from "£lement/ChartGauge";
import NoItemsContainer from "~/components/NoItemsContainer";
import { CChartLine } from "@coreui/vue-chartjs";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/**
 * Others
 */
import { cilPlus, cilSettings, cilBullhorn } from "@coreui/icons";
import { mapGetters } from "vuex";
import { adapterCreatedAtInChars } from "~/utils/date";
import CampaignsTable from "./config/tables/campaings";
import { eraser } from "~/assets/icons/js/eraser";

export default {
    name: "CampaignsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        FilterFields,
        CChartLine,
        ChartGauge,
        TableSettings,
        ButtonCreate,
        ButtonExport,
        NoItemsContainer,
        CCTable,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilBullhorn,
        eraser,
    },
    data() {
        return {
            tables: {
                campaigns: CampaignsTable,
            },
            charts: {
                providers_input_history: {
                    labels: [],
                    datasets: [],
                    loading: true,
                    options: {
                        tooltips: {
                            titleMarginBottom: 10,
                            titleFontColor: "#6e707e",
                            titleFontSize: 14,
                            backgroundColor: "rgb(255,255,255)",
                            bodyFontColor: "#858796",
                            borderColor: "#dddfeb",
                            borderWidth: 1,
                            xPadding: 15,
                            yPadding: 15,
                            displayColors: false,
                            caretPadding: 10,
                        },
                        maintainAspectRatio: false,
                        layout: {
                            padding: {
                                left: 10,
                                right: 25,
                                top: 25,
                                bottom: 0,
                            },
                        },
                        scales: {
                            xAxes: [
                                {
                                    time: {
                                        unit: "month",
                                    },
                                    gridLines: {
                                        color: "rgb(234, 236, 244)",
                                        zeroLineColor: "rgb(234, 236, 244)",
                                        drawBorder: false,
                                        borderDash: [2],
                                        zeroLineBorderDash: [2],
                                    },
                                    ticks: {
                                        min: 0,
                                        maxTicksLimit: 15,
                                        padding: 10,
                                    },
                                },
                            ],
                            yAxes: [
                                {
                                    ticks: {
                                        min: 0,
                                        maxTicksLimit: 15,
                                        padding: 10,
                                        // Include a dollar sign in the ticks
                                    },
                                    gridLines: {
                                        color: "rgb(234, 236, 244)",
                                        zeroLineColor: "rgb(234, 236, 244)",
                                        drawBorder: false,
                                        borderDash: [2],
                                        zeroLineBorderDash: [2],
                                    },
                                },
                            ],
                        },
                    },
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            default_colors: "global/default_colors",
            from: "filter/from",
            to: "filter/to",
        }),
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.campaigns.rows = newValue;
            this.updatePagination(this.tables.campaigns.page);
        },
        updatePagination(newValue) {
            this.tables.campaigns.page = newValue;
            this.updateData();
        },

        async updateData() {
            await this.updateTable({
                tableName: "campaigns",
                url: "/input.api/list",
            });
            this.tables.campaigns.itemSelected = null;

            this.loadLanguageInTable({
                tableName: "campaigns",
                fielLanguageName: "language_id",
            });
            this.loadCountryInTable({
                tableName: "campaigns",
                fielCountryName: "country_id",
            });
            await this.loadChartProvidersInputHistory({
                from: this.from,
                to: this.to,
            });
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },

        async loadChartProvidersInputHistory({ from, to }) {
            this.charts.providers_input_history.loading = true;
            let list_data = this.tables.campaigns.items;

            var fetcherCollection = list_data.map((item) => {
                return {
                    url:
                        "/campaings.api/inputs/" + item.uuid + "/stats/history",
                    query: {
                        query: this.createQuery({
                            where: {
                                date: {
                                    between: [from, to, false],
                                },
                            },
                        }),
                    },
                };
            });

            let resolveFetcherCollection = await this.mapFetcher(
                fetcherCollection
            );

            adapterCreatedAtInChars(resolveFetcherCollection);
            let chart_data = resolveFetcherCollection;
            let labels_dataset = list_data.map((item) => item.name);

            this.loadChart({
                chart_name: "providers_input_history",
                labels_dataset,
                chart_data,
                field_chart_data: "count",
                filed_chart_label: "created_at",
                colors: this.default_colors,
            });
        },
        getBadge(active) {
            if (typeof active === "string") {
                active = active == "1" ? true : false;
            }
            if (active) return { label: "active", color: "success" };
            else return { label: "stop", color: "secondary" };
        },
    },
    beforeRouteUpdate(to, from, next) {
        this.resetFiltersInTable({
            tableName: "campaigns",
        })
        this.updateData();
        next(); // Continúa con la navegación
    },
    beforeRouteLeave(to, from, next) {
        this.resetFiltersInTable({
            tableName: "campaigns",
        })
        next();
    },
    mounted() {
        this.updateData();
    },
    created() {
        this.loadLanguages();
        this.loadCountries();
    },
};
</script>

<style scoped lang="scss"></style>
